<form
  [formRoot]="createTaskForm()"
  class="flex flex-col w-full gap-5"
>
  @if (firstStep()) {
    <div class="flex w-full flex-col items-center justify-center gap-5">
      <p class="text-base">{{ 'task-create-select-task-type' | translate }}</p>
      <div class="w-full md:w-1/2 grid grid-cols-1 gap-2.5">
        @for (type of taskTypes(); track type.id) {
          <button
            (click)="selectTaskType(type.id)"
            class="flex w-full border-hover bg-proffeo-surface px-2 py-4 items-center justify-center hover:bg-proffeo-surface-muted transition-default"
          >
            <p>{{ type.code + ' ' + type.name }}</p>
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="grid grid-cols-2 w-full gap-5">
      <proffeo-ui-tree-select
        [formField]="createTaskForm().locationId"
        [nodes]="locationNodes()"
        [searchable]="true"
        [translateLabels]="false"
        label="task-create-location"
        class="w-full"
      />
      <proffeo-ui-select
        [formField]="createTaskForm().industryId"
        [options]="industrySelectOptions()"
        [translateLabels]="false"
        label="task-create-task-industry"
        class="w-full"
      />
    </div>
    <div class="flex flex-col gap-5 w-full">
      <proffeo-ui-input
        [formField]="createTaskForm().name"
        errorMessage="project-tasks.create.title-required-error"
        label="task-create-task-title"
      />

      <proffeo-ui-tiptap-editor
        [formField]="createTaskForm().description"
        placeholder="task-create-description"
        variant="field"
      />

      <div class="flex flex-col w-full gap-3">
        <proffeo-file-drop (filesAdded)="onFilesAdded($event)"></proffeo-file-drop>

        <div class="flex gap-1.5 items-center w-full overflow-x-auto">
          @for (file of files(); track $index) {
            <div class="flex relative p-1.5 items-center justify-center">
              <div
                class="flex w-14 h-14 items-center justify-center border border-proffeo-border rounded-md bg-proffeo-surface"
              >
                <span
                  (click)="onRemoveFile(file)"
                  class="flex w-6 h-6 rounded-full bg-proffeo-surface-active items-center justify-center aspect-square absolute right-0 top-0 cursor-pointer transition-default hover:bg-proffeo-surface-hover"
                >
                  <mat-icon
                    fontIcon="delete"
                    class="icon-sm icon-white"
                  />
                </span>
                @if (previewUrls().get(file); as previewUrl) {
                  <img
                    [src]="previewUrl"
                    class="w-14 h-14 rounded-md"
                  />
                } @else {
                  <div class="w-14 h-14 flex items-center justify-center rounded-md text-proffeo-muted">
                    <mat-icon
                      fontIcon="description"
                      class="icon-md"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (filesSizeError(); as filesSizeError) {
        <mat-error>
          {{
            'ui-forms-files-max-size-exceeded'
              | translate
                : {
                    actualSize: filesSizeError.actualSizeInMB,
                    maxSize: filesSizeError.maxSizeInMB
                  }
          }}
        </mat-error>
      }
    </div>
  }
</form>
